/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum PolicyEnum {
    access_governance_dashboard = 'access_governance_dashboard',
    access_posture = 'access_posture',
    account_governance = 'account_governance',
    accountmaster_support_dashboard = 'accountmaster_support_dashboard',
    ai_dashboard = 'ai_dashboard',
    ai_observability_dashboard = 'ai_observability_dashboard',
    alarms = 'alarms',
    anomaly_detector = 'anomaly_detector',
    anthropic_agent = 'anthropic_agent',
    application = 'application',
    application_management = 'application_management',
    approve_assessment = 'approve_assessment',
    approver_dashboard_tenant = 'approver_dashboard_tenant',
    appsecops_agent = 'appsecops_agent',
    assessment_agent = 'assessment_agent',
    rate_optimization_agent = 'rate_optimization_agent',
    finops_agent = 'finops_agent',
    appsecops_dashboard = 'appsecops_dashboard',
    assessment_approver = 'assessment_approver',
    assessment_contributor = 'assessment_contributor',
    assessment_execution = 'assessment_execution',
    assessment_management = 'assessment_management',
    associated_accounts = 'associated_accounts',
    audit = 'audit',
    automation_dashboard = 'automation_dashboard',
    automation_workflow = 'automation_workflow',
    aws_security_hub = 'aws_security_hub',
    aws_security_hub_dashboard = 'aws_security_hub_dashboard',
    aws_ssm = 'aws_ssm',
    azure_devops_dashboard = 'azure_devops_dashboard',
    azure_security_graph = 'azure_security_graph',
    azure_sentinel = 'azure_sentinel',
    basic_access = 'basic_access',
    bedrock_agent = 'bedrock_agent',
    billing_inventory = 'billing_inventory',
    billing_metric = 'billing_metric',
    billing_plans = 'billing_plans',
    blueprint_jobs = 'blueprint_jobs',
    blueprints = 'blueprints',
    budget_management = 'budget_management',
    builds_dashboard = 'builds_dashboard',
    cloud_and_tool_accounts = 'cloud_and_tool_accounts',
    cloudaccount_support_dashboard = 'cloudaccount_support_dashboard',
    compass_administrator = 'compass_administrator',
    compliance_control = 'compliance_control',
    compliance_control_definitions = 'compliance_control_definitions',
    compliance_control_mapping = 'compliance_control_mapping',
    compliance_dashboard = 'compliance_dashboard',
    cost_analysis_report = 'cost_analysis_report',
    cost_anomaly = 'cost_anomaly',
    cost_billing_operations = 'cost_billing_operations',
    cost_budget_management = 'cost_budget_management',
    cost_dashboard = 'cost_dashboard',
    cost_posture = 'cost_posture',
    cost_savings_and_recommendations = 'cost_savings_and_recommendations',
    create_reports = 'create_reports',
    currency_exchange_plans = 'currency_exchange_plans',
    custom_reports = 'custom_reports',
    customer_support_dashboard = 'customer_support_dashboard',
    dashboard_subscribe = 'dashboard_subscribe',
    dashboard_v2 = 'dashboard_v2',
    dimension = 'dimension',
    dpo = 'dpo',
    faq = 'faq',
    finance_dashboard_account = 'finance_dashboard_account',
    inventory = 'inventory',
    inventory_actions = 'inventory_actions',
    inventory_elements = 'inventory_elements',
    itsm_cmdb = 'itsm_cmdb',
    itsm_configuration = 'itsm_configuration',
    itsm_request = 'itsm_request',
    maintenance = 'maintenance',
    manage_workload_owner = 'manage_workload_owner',
    marketplace_support_dashboard = 'marketplace_support_dashboard',
    markup_discount = 'markup_discount',
    master_account = 'master_account',
    milestone_management = 'milestone_management',
    monitoring_alerts = 'monitoring_alerts',
    notification_service = 'notification_service',
    operation_posture = 'operation_posture',
    operations_activity = 'operations_activity',
    operations_dashboard = 'operations_dashboard',
    operations_report = 'operations_report',
    payment = 'payment',
    policies = 'policies',
    policy_data = 'policy_data',
    policy_exclusions = 'policy_exclusions',
    policy_jobs = 'policy_jobs',
    portfolio_management = 'portfolio_management',
    product_bundle = 'product_bundle',
    project_management = 'project_management',
    quota_management = 'quota_management',
    recommendations = 'recommendations',
    recommendations_dashboard = 'recommendations_dashboard',
    recommendations_dashboard_v2 = 'recommendations_dashboard_v2',
    reports = 'reports',
    reservation_recommendations = 'reservation_recommendations',
    reservation_utilization = 'reservation_utilization',
    resource_consistency_dashboard = 'resource_consistency_dashboard',
    resource_list = 'resource_list',
    resource_locks = 'resource_locks',
    resource_posture = 'resource_posture',
    resource_tags = 'resource_tags',
    roles = 'roles',
    saas_accounts_onboarding = 'saas_accounts_onboarding',
    saas_agreements = 'saas_agreements',
    saas_billing_plans = 'saas_billing_plans',
    saas_budget_management = 'saas_budget_management',
    saas_cloud_ai_dashboard = 'saas_cloud_ai_dashboard',
    saas_cloud_dashboard = 'saas_cloud_dashboard',
    saas_cost_anomaly = 'saas_cost_anomaly',
    saas_dashboard = 'saas_dashboard',
    saas_dimension = 'saas_dimension',
    saas_products = 'saas_products',
    saas_spend_optimization_dashboard = 'saas_spend_optimization_dashboard',
    sbom_management = 'sbom_management',
    schedules = 'schedules',
    scope = 'scope',
    secops_dashboard_v2 = 'secops_dashboard_v2',
    security_operations_dashboard = 'security_operations_dashboard',
    security_posture = 'security_posture',
    signup_users = 'signup_users',
    subscription = 'subscription',
    tag_pattern = 'tag_pattern',
    tagging_governance_baselines = 'tagging_governance_baselines',
    template_jobs = 'template_jobs',
    templates = 'templates',
    tenant_support_dashboard = 'tenant_support_dashboard',
    tenants = 'tenants',
    terms_conditions = 'terms_conditions',
    tools_integrations = 'tools_integrations',
    transaction = 'transaction',
    usage_optimization_agent = 'usage_optimization_agent',
    user_delegation = 'user_delegation',
    user_support_dashboard = 'user_support_dashboard',
    usergroup = 'usergroup',
    users = 'users',
    utilization_metrics = 'utilization_metrics',
    visualiser = 'visualiser',
    wellarchitected_frameworks = 'wellarchitected_frameworks',
    workload_contributor = 'workload_contributor',
    workload_management = 'workload_management'
}
